import React, { memo, useState } from 'react'
import { useParams } from 'react-router-dom'
import { BaseRouteParams } from 'hocs'
import styled from 'styled-typed'
import { ActionButtonA } from 'uiComponents/buttons'
import { useHasFeature } from '../../../features'
import RequestMapDialog from './customOverlayRequest'
import welcomeImage from '../assets/welcome.png'
import { Body, Headline } from 'uiComponents/typography'
import { useTranslation } from 'translations'

const Container = styled.div`
    height: 660px;
    max-width: 1200px;
    background: #ffffff;
    display: flex;
    flex-direction: row;
`

const Buttons = styled.div`
    margin-top: 63px;
    display: flex;
    flex-direction: row;
    
    gap: 8px;
`

const Content = styled.div`
    padding: 100px 84px;
`

const Image = styled.img.attrs((props) => ({ src: welcomeImage }))`
    flex: 1;
`

const ParkMapWelcomePage = () => {
    const { t } = useTranslation()
    const { accountSlug } = useParams<BaseRouteParams>()
    const [requestMapDialogVisible, setRequestMapDialogVisible] = useState<boolean>(false)
    /*
        to activate button for specific partner go to BO,
        search for parkmap_paid component and
        set enable value for selected partner
     */
    const displayBuildButton = useHasFeature('parkmap_paid')

    return (
        <>
            {requestMapDialogVisible && <RequestMapDialog onCancel={() => setRequestMapDialogVisible(false)} />}
            <Container>
                <Content>
                    <Headline size={4} style={{ margin: '0 0 32px 0' }}>
                        {t('venue.parkMap.welcome.title')}
                    </Headline>
                    <Body size={1} weight="regular">
                        {t('venue.parkMap.welcome.description')}
                    </Body>
                    <Buttons>
                        {displayBuildButton && (
                            <ActionButtonA href={`/account/${accountSlug}/venue/park_map/create/details`} size="large">
                                {t('venue.parkMap.welcome.startBuilding')}
                            </ActionButtonA>
                        )}
                        <ActionButtonA onClick={() => setRequestMapDialogVisible(true)} kind="action" size="large">
                            {t('venue.parkMap.welcome.getStarted')}
                        </ActionButtonA>
                    </Buttons>
                </Content>
                <Image />
            </Container>
        </>
    )
}

export default memo(ParkMapWelcomePage)
